module.exports = __webpack_public_path__ + "static/media/Congrats.95a169b3.gif";